import { useCallback } from 'react';

import { useXFetch } from '~/shared/utils/useXFetch';

export function useExportFetch() {
  const api = useXFetch();

  const fetchCount = useCallback(
    async (countUrl: string): Promise<number> => {
      const response = await api<{ count?: number }>(countUrl);
      return response.count ?? 0;
    },
    [api]
  );

  const fetchData = useCallback(
    async (
      dataUrl: string,
      countUrl: string,
      initialOffset = 0,
      responseKey?: string
    ): Promise<unknown[]> => {
      const total = await fetchCount(countUrl);
      if (total === 0) return [];

      const url = new URL(dataUrl, window.location.origin);
      // The API has no server-side page-size cap, so a single request with limit=total is safe.
      url.searchParams.set('limit', String(total));
      url.searchParams.set('offset', String(initialOffset));

      const response = await api<Record<string, unknown>>(`${url.pathname}${url.search}`);

      const arrayKey =
        responseKey && Array.isArray(response[responseKey])
          ? responseKey
          : Object.keys(response).find((k) => Array.isArray(response[k]));

      if (!arrayKey) return [];

      return (response[arrayKey] as unknown[]) ?? [];
    },
    [api, fetchCount]
  );

  return { fetchCount, fetchData };
}
